import React from 'react';

function Phone(props) {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" {...props}>
      <path
        d="M8.98583 6.44274C8.64115 6.10256 8.21375 6.10256 7.87367 6.44274C7.61171 6.70017 7.35435 6.9576 7.09699 7.21963C7.02806 7.29318 6.96831 7.30697 6.88099 7.261C6.71095 7.16906 6.53172 7.09551 6.37087 6.99437C5.61717 6.52089 4.98297 5.90949 4.42689 5.22454C4.15114 4.88436 3.90298 4.51661 3.72834 4.10748C3.69617 4.02013 3.70076 3.96497 3.7697 3.90061C4.03166 3.64778 4.28442 3.39035 4.54178 3.13292C4.90024 2.77435 4.90024 2.35603 4.54178 1.99287C4.33497 1.786 4.13276 1.58374 3.92595 1.38147C3.71915 1.17001 3.50774 0.958548 3.29634 0.751684C2.95166 0.416105 2.52426 0.416105 2.18418 0.751684C1.92223 1.00911 1.66946 1.27574 1.40291 1.52857C1.15474 1.76302 1.03066 2.04803 1.00768 2.38361C0.966319 2.92605 1.09959 3.44091 1.28802 3.94198C1.67406 4.9809 2.25771 5.90029 2.97005 6.74154C3.93055 7.88159 5.07488 8.78719 6.41683 9.43996C7.01886 9.73417 7.64388 9.95942 8.32404 9.9962C8.79281 10.0238 9.19723 9.90426 9.52352 9.5411C9.74871 9.29286 9.99688 9.06301 10.2359 8.82397C10.5851 8.47 10.5897 8.04248 10.2405 7.69311C9.82224 7.27479 9.40403 6.85647 8.98583 6.44274Z"
        stroke="#3E3E40"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Phone;
